// extracted by mini-css-extract-plugin
export default {"item":"PatientTherapySelectInput_item__0VFj7"};